import Pusher from "pusher-js";
import { authFetch, API_BASE } from "./HttpClient";

let instance = null;
let warned = false;

// Singleton Pusher partagé — l'authorizer passe par authFetch (JWT +
// rewrite d'URL localhost/prod + gestion session expirée automatiques,
// comme tout appel backend ailleurs dans l'app, voir HttpClient.js).
// Renvoie null si REACT_APP_PUSHER_KEY manque (config absente/pas encore
// redémarrée) plutôt que de faire planter l'app : Discussion doit rester
// utilisable via son filet de secours (poll), jamais dépendante à 100% de
// Pusher — voir useDiscussion.js.
function getPusherClient() {
  if (instance) return instance;

  if (!process.env.REACT_APP_PUSHER_KEY) {
    if (!warned) {
      console.error(
        "REACT_APP_PUSHER_KEY manquant — le temps réel de Discussion est désactivé (repli sur le poll). " +
          "Vérifiez .env.development/.env.production puis redémarrez le serveur de dev (npm start).",
      );
      warned = true;
    }
    return null;
  }

  instance = new Pusher(process.env.REACT_APP_PUSHER_KEY, {
    cluster: process.env.REACT_APP_PUSHER_CLUSTER,
    authorizer: (channel) => ({
      authorize: async (socketId, callback) => {
        try {
          const res = await authFetch(`${API_BASE}/api/discussion/pusher/auth`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ socket_id: socketId, channel_name: channel.name }),
          });
          if (!res.ok) throw new Error("Auth Pusher refusée");
          callback(null, await res.json());
        } catch (err) {
          callback(err, null);
        }
      },
    }),
  });

  return instance;
}

export default getPusherClient;
